import { CompiledInfluxQueryObject, TagSelector } from '@/composables/charts/influx-charts/query-builders/InfluxTypes'
import { SerializedRegionSumChart } from '@/composables/charts/influx-charts/chart-builders/ChartInterfaces'
import { CHART_TYPES } from '@/composables/charts/influx-charts/chart-builders/CHART_TYPES'
import { AbstractInfluxLineChartBuilder } from '@/composables/charts/influx-charts/chart-builders/AbstractInfluxLineChartBuilder'

export class RegionSumInfluxChartBuilder extends AbstractInfluxLineChartBuilder {
  regionSumProperty: string
  field: string = 'meanCount'
  regionSumValueTagSelector: TagSelector<'value'>

  constructor(serialized: SerializedRegionSumChart) {
    super(serialized)
    if (serialized.field) this.field = serialized.field
    this.regionSumProperty = serialized.regionSumProperty
    this.regionSumValueTagSelector = serialized.regionSumValueTagSelector
    this.setRegionSumBasedQueryParameters()
  }

  buildQuery(): CompiledInfluxQueryObject {
    return this.buildQueryForSingleQuery('regionSums', this.field)
  }

  setRegionSumBasedQueryParameters() {
    const compiledTransientWhereClauses = this.transientWhereClauses ? this.transientWhereClauses : {}
    compiledTransientWhereClauses.property = this.regionSumProperty
    if (!this.transientTagSelectors) this.transientTagSelectors = []
    this.transientTagSelectors.push(this.regionSumValueTagSelector)
    this.transientWhereClauses = compiledTransientWhereClauses
  }
  serialize(): SerializedRegionSumChart {
    return {
      ...super.serialize(),
      chartType: CHART_TYPES.REGION_SUMS,
      regionSumProperty: this.regionSumProperty,
      regionSumValueTagSelector: this.regionSumValueTagSelector,
      field: this.field,
    }
  }
  autoInferChartEntity(serialized?: SerializedRegionSumChart): string | undefined {
    const localRegionSumProperty = this.regionSumProperty ? this.regionSumProperty : serialized?.regionSumProperty
    if (!localRegionSumProperty) return undefined
    if (localRegionSumProperty === 'stalltechnik') return 'frontend-charts.barnEquipment'
    if (localRegionSumProperty === 'stallbereich_vh') return 'frontend-charts.frontBack'
    if (localRegionSumProperty === 'stallbereich_lr') return 'frontend-charts.leftRight'
    return `frontend-charts.${localRegionSumProperty}`
  }
}
